import React, { useMemo, useCallback } from "react";
import { useFormikContext } from "formik";
import { FieldHelperText, SelectInput } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";
import { FieldLabel, InputContainer } from "../components";
import { useInitialState } from "../contexts/initial-state-context";

const StatusField = React.memo(() => {
  const { preIntakeStatuses } = useInitialState();
  const { values, errors, setFieldValue } = useFormikContext();

  const options = useMemo(() => {
    return preIntakeStatuses.map((preIntakeStatusCode) => ({
      value: preIntakeStatusCode,
      label: translate(null, "teladoc_constants_gem.consult_events.status_reasons_localized", preIntakeStatusCode),
    }));
  }, [preIntakeStatuses]);

  const handleChange = useCallback((value) => {
    setFieldValue(fieldTypes.STATUS, value, true);
  }, []);

  return (
    <React.Fragment>
      <FieldLabel>
        {translate(null, "pre_intake.fields.status", "label")}

        <InputContainer>
          <SelectInput
            isSearchable={false}
            options={options}
            value={values[fieldTypes.STATUS]}
            onChange={handleChange}
            placeholder={translate(null, "pre_intake.fields.status", "placeholder")}
            customStyles={{
              container: (provided) => ({
                ...provided,
                width: 280,
              }),
            }}
          />

          <FieldHelperText error={!!errors[fieldTypes.STATUS]}>
            {errors[fieldTypes.STATUS]}
          </FieldHelperText>
        </InputContainer>
      </FieldLabel>
    </React.Fragment>
  );
});

StatusField.displayName = "StatusField";

export default StatusField;
